<div class="panel-header-alignment">
    @if (enableCorrectScoreOptionGroupToggle) {
        <ms-toggle-view-button />
    }
    @if (deviceService.isMobile && winMarketName) {
        <div class="option-group-win-market-mobile">
            <span>{{ winMarketName }}</span>
        </div>
    }
    @if (marketLogoShowInHeader) {
        <ms-marketsubtype-logo
            tooltipPlacement="bottom"
            arrowPosition="end"
            [eventId]="event.id"
            [marketType]="marketType"
            [marketSubType]="marketSubType"
            [matchName]="event.name"
            [sportId]="event.sport.id"
            [trackingLocation]="'edp'"
            [tooltipAppendTo]="tooltipAppendto ?? ''"
            [tooltipBoundaries]="tooltipAppendto ?? ''"
            [chevronShown]="shouldShowChevron"
            [templateId]="templateId" />
    }
    @switch (badgeTypeToShow()) {
        @case ('sgp') {
            <ms-sgp-badge size="large" />
        }
        @case ('betbuilder') {
            <ms-market-header-bet-builder-badge />
        }
    }
    @if (!optionGroup.online) {
        <div [ngClass]="showSuspendedSelection ? 'lock-icon-div' : ''">
            <vn-icon
                [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"
                [size]="isEpcotEnabled ? '12' : '14'"
                [ngClass]="{ 'option-group-lock-icon': !isEpcotEnabled }" />
        </div>
    }
    @if (promoted) {
        <div class="promotion-badge-icon">
            <vn-icon name="theme-badge" [size]="isEpcotEnabled ? '12' : '14'" />
        </div>
    }
    @if (optionGroup.extended) {
        <ms-extended-offer />
    }
    @if (showEventChevron && isLinkToEvent) {
        <vn-icon name="theme-right" [size]="isEpcotEnabled ? '12' : '14'" />
    }
</div>
